import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

export default function ProtectedRoute() {
  const { user, token, hasCheckedAuth } = useSelector((state) => state.auth);

  // Espera o /auth/me rodar 1x no boot
  if (!hasCheckedAuth) return null; // depois colocamos um spinner

  const isAuthed = !!user || !!token;
  if (!isAuthed) return <Navigate to="/login" replace />;

  return <Outlet />;
}
